





























import CommonBase from "../CommonBase";
import {Component, Prop} from "vue-property-decorator";
import InfoDialog from "../InfoDialog.vue";
import {Terminal} from "../../modules/models";
import {TerminalWarrantyYears} from "@/modules/constants";
import rd from "@/modules/vRoutedefs";

@Component({
  components: {
    "at-info-dialog": InfoDialog,
  }
})
export default class TerminalAgeDialog extends CommonBase {
  @Prop({default: false})
  value!: boolean;

  @Prop()
  terminal!: Terminal;

  readonly warrantyYears = TerminalWarrantyYears;

  readonly webshopTo = {name: rd.shop.name};

  get model() {
    return this.value;
  }
  set model(v: boolean) {
    this.$emit("input", v);
  }

  technicalCheckDone() {
    this.$emit("at-technical-check-done");
  }
}
